import * as Yup from "yup";

export const IncapacityPartnerShema = Yup.object().shape({
  title: Yup.string().required("Campo requerido"),
  description: Yup.string().required("Campo requerido"),
});
